<template lang="html">
  <v-app light>
    <v-layout>
      <v-flex
        xs12
        sm6
        offset-sm3
        class="login_wrapper"
      >
        <v-card class="login_cardwrappper">
          <v-img
            :src="require('../../assets/img/logo.png')"
            :contain="true"
            height="100px"
          />
          <v-card-actions>
            <v-form
              v-model="valid"
              class="login_form_wrapper"
            >
              <v-text-field
                v-model.trim="user"
                v-model="user"
                v-validate="'required'"
                label="Имя"
                name="user"
                :rules="(!errors.first('user')) ? [true] : [errors.first('user')]"
                required
              />

              <v-text-field
                v-model.trim="password"
                v-model="password"
                v-validate="'required'"
                label="Пароль"
                type="password"
                name="password"
                :rules="(!errors.first('password')) ? [true] : [errors.first('password')]"
                required
              />
              <span class="cmd-container">
                <span
                  v-show="autherror"
                  class="cmd-error"
                >{{ autherror }}</span>
              </span>
              <p class="text-right">
                <v-btn @click="login">
                  Войти
                </v-btn>
              </p>
            </v-form>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script type="text/javascript">
import axios from 'axios'

export default {
  components: {},
  data () {
    return {
      valid: false,
      user: '',
      password: '',
      autherror: ''
    }
  },
  beforeCreate () {
    // if (this.$store.state.isLogged) {
    //   this.$router.push('/')
    // }
  },
  methods: {
    login () {
      this.autherror = ''
      if (!this.valid || !this.user || !this.password) {
        return
      }
      axios.post('/api/api-token-auth/', {
        username: this.user,
        password: this.password
      }).then((response) => {
        localStorage.setItem('token', response.data.token)
        this.$store.commit('LOGIN_USER')
        this.$router.push({ path: '/' })
      }).catch((response) => {
        console.warn(response)
        this.autherror = 'Неверный логин или пароль'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
    .login_wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .login_cardwrappper {
        min-width: 300px;
        width: 22%;
    }

    .login_form_wrapper {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/spa/login/Login.vue